// add dev website hostname to WebsiteHostName then include api domain in ACCOUNT_MAPPINGS

enum WebsiteHostName {
  PROD = "instructions.siteconnect.opstech.a2z.com",
  BETA = "instructions-beta.siteconnect.opstech.a2z.com",
}

export const ACCOUNT_MAPPINGS = new Map<string, string>([]);
ACCOUNT_MAPPINGS.set(
  WebsiteHostName.PROD,
  "instructions.api.siteconnect.opstech.a2z.com"
);
ACCOUNT_MAPPINGS.set(
  WebsiteHostName.BETA,
  "instructions-beta.api.siteconnect.opstech.a2z.com"
);


/** String constants used throughout the application */

export const shellFlags = 'Set-ExecutionPolicy -ExecutionPolicy Unrestricted -Scope Process -Force';
export const installCodeText = [shellFlags, '& "C:\\Program Files (x86)\\Amazon\\SiteConnect\\configure-siteconnect.ps1" install'].join('\n');
export const updateCodeText = [shellFlags, '& "C:\\Program Files (x86)\\Amazon\\SiteConnect\\configure-siteconnect.ps1" update'].join('\n');
export const uninstallCodeText = [shellFlags, `& "C:\\Program Files (x86)\\Amazon\\SiteConnect\\configure-siteconnect.ps1" uninstall`].join('\n');
export const powershellLogCode = `Get-ChildItem "$($env:USERPROFILE)\\AppData\\Roaming\\AWSVPNClient\\logs" | Sort-Object -Property CreationTime | Where-Object { $_.FullName -like "*ovpn_aws_vpn_client*"} | Select-Object -Last 1 FullName`;
